import styled, { keyframes } from 'styled-components'

import { minmedia } from '../../styles/media-queries'
import { gold, body, white, red } from '../../styles/colors'

// const animateWidth = keyframes`
//   0% {
//     width: ${props => (props.from ? props.from : '0%')};
//   } 100% {
//     width: ${props => (props.to ? props.to : '0%')};
//   }
// `

function animation(props) {
  return keyframes`
    0% {
      width: ${props.from};
    } 100% {
      width: ${props.to};
    }
  `
}

export const Spinner = styled.div`
  width: ${props => (props.fixed ? '075px' : '15%')};
  ${minmedia.medium`
  width: ${props => (props.fixed ? '075px' : '15%')};
`} ${minmedia.large`
  width: ${props => (props.fixed ? '075px' : '15%')};
`};

  padding: 1rem;
  position: relative;
  border-radius: 100%;
  &::before {
    display: block;
    content: '';
    padding-top: 100%;
  }
  img {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: calc(100%);
    height: calc(100%);
    object-position: center center;
    object-fit: contain;
  }
`

export const Bar = styled.div`
  width: ${props => (props.fixed ? '075px' : '50%')};
  ${minmedia.medium`
    width: ${props => (props.fixed ? '075px' : '25%')};
  `} ${minmedia.large`
    width: ${props => (props.fixed ? '075px' : '15%')};
  `};
  height: 1rem;
  background: ${gold};
  border-radius: 0.5rem;
  position: relative;
  &::after {
    width: ${props => (props.from ? props.from : '0%')};
    height: 100%;
    background: ${red};
    content: '';
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    border-radius: 0.5rem;
    animation: ${props => `${animation(props)} 0.5s 1`};
    animation-fill-mode: forwards;
  }
`

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  position: absolute;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  background: ${props => (props.fixed ? body : white)};
  z-index: 100;
`



// WEBPACK FOOTER //
// ./src/components/Loader/styles.js